import { IonButton, IonSpinner } from "@ionic/react";
import { RATE_NEGOTIATION_COMMIT_MODAL } from "@src/constants/modalAlerts";
import { CustomModal } from "@src/utils/CustomModal";
import { FC } from "react";

import { INegotiationCommitModalProps, NegotiationCommitType } from "./interfaces";

import "./style.scss";

export const NegotiationCommitModal: FC<INegotiationCommitModalProps> = ({
  isOpen,
  rate,
  formattedTimeText,
  onCommit,
  closeModal,
  modalType,
  requestLoading,
}) => {
  if (!isOpen) {
    return null;
  }
  let modalText;
  if (modalType === NegotiationCommitType.PROPOSE_NEW_RATE) {
    modalText = RATE_NEGOTIATION_COMMIT_MODAL[modalType].CONTENT(rate);
  } else if (modalType === NegotiationCommitType.PROPOSE_NEW_TIME) {
    modalText = RATE_NEGOTIATION_COMMIT_MODAL[modalType].CONTENT(formattedTimeText);
  } else {
    modalText = RATE_NEGOTIATION_COMMIT_MODAL[modalType].CONTENT;
  }

  return (
    <CustomModal
      open={isOpen}
      closable={false}
      title={RATE_NEGOTIATION_COMMIT_MODAL[modalType].TITLE}
      centered={true}
      mainClassName="custom-modal negotiation-commit-modal"
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "center",
        padding: "10px",
      }}
      body={
        <>
          <p data-testid="modal-subtitle-top" className="negotiation-commit-text">
            {modalText}
          </p>
          <p data-testid="modal-subtitle-bottom" className="negotiation-commit-text">
            {RATE_NEGOTIATION_COMMIT_MODAL[modalType].SUB_CONTENT}
          </p>
        </>
      }
      footer={
        <div className="negotiation-commit-action-container">
          <IonButton
            expand="full"
            shape="round"
            id="commit-negotiation-btn"
            className={`propose-rate-button ${
              modalType === NegotiationCommitType.END_NEGOTIATION ? "end-negotiation" : ""
            }`}
            fill="outline"
            onClick={onCommit}
          >
            {requestLoading ? (
              <div className="network-loading" data-testid="network-loading">
                <IonSpinner />
              </div>
            ) : (
              RATE_NEGOTIATION_COMMIT_MODAL[modalType].BUTTON_TEXT
            )}
          </IonButton>
          <IonButton
            expand="full"
            shape="round"
            style={{
              "--border-color": "#828282",
              "--color": "#828282",
            }}
            fill="outline"
            id="close-negotiation-btn"
            onClick={closeModal}
          >
            Cancel
          </IonButton>
        </div>
      }
    />
  );
};
